import { render, staticRenderFns } from "./Zan.vue?vue&type=template&id=ae3b3aba&scoped=true&"
import script from "./Zan.vue?vue&type=script&lang=js&"
export * from "./Zan.vue?vue&type=script&lang=js&"
import style0 from "./Zan.vue?vue&type=style&index=0&id=ae3b3aba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3b3aba",
  null
  
)

export default component.exports